import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import MasterZipCodeService from "services/Setup/Master/masterZipCodeService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  provinceCodeList: {},
  cityCodeList: {},
  districtCodeList: {},
  villageCodeList: {},
  postalCodeList: {},
  // OriginationIdList: [{ code: "", name: "" }],
  // MasterCustomerAttributeList: [{ code: "", name: "" }],
  legalCodeList: {},
  keyCity: {},
  kotaMadyaList: {},
};

export const getProvinceCodeList = createAsyncThunk(
  "masterProvinceCode/getProvinceCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getProvinceCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getCityCodeList = createAsyncThunk(
  "masterAllLocation/getCityCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getCityCodeList(userInput);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getDistrictCodeList = createAsyncThunk(
  "masterAllLocation/getDistrictCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getDistrictCodeList(
        userInput
      );
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getVillageCodeList = createAsyncThunk(
  "masterAllLocation/getVillageCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getVillageCodeList(userInput);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getPostalCodeList = createAsyncThunk(
  "masterAllLocation/getPostalCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getPostalCodeList(userInput);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getLegalCodeList = createAsyncThunk(
  "masterProvinceCode/getLegalCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getLegalCodeList(userInput);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getTojkkabupatenkotaList = createAsyncThunk(
  "masterProvinceCode/getTojkkabupatenkotaList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterZipCodeService.getLegalCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

// export const getGenderCustomerCodeList = createAsyncThunk(
//   "masterZipCode/getGenderCustomerCodeList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await MasterZipCodeService.getGenderCustomerCodeList();
//       if (response) {
//         return response;
//       } else {
//         return { status: "Ok", message: "Unexpected response!" };
//       }
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Catched error!");
//     }
//   }
// );

// export const getMaritalStatusCodeList = createAsyncThunk(
//   "masterZipCode/getMaritalStatusCodeList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await MasterZipCodeService.getMaritalStatusCodeList();
//       if (response) {
//         return response;
//       } else {
//         return { status: "Ok", message: "Unexpected response!" };
//       }
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Catched error!");
//     }
//   }
// );

export const masterZipCode = createSlice({
  name: "masterZipCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    setkeyCity: (state, action) => {
      state.keyCity = action.payload;
    },
    resetProvinceCodeList: (state) => {
      // state.provinceCodeList = {};
      console.log("🚀 ~ state.provinceCodeList = {};:", "");
    },
    resetCityCodeList: (state) => {
      state.cityCodeList = {};
    },
    resetDistrictCodeList: (state) => {
      state.districtCodeList = {};
    },
    resetVillageCodeList: (state) => {
      state.villageCodeList = {};
    },
    resetPostalCodeList: (state) => {
      state.postalCodeList = {};
    },
    resetLegalCodeList: (state) => {
      state.legalCodeList = {};
    },
    resetAllZipCodeStates: (state) => {
      return initialState; // Reset all states to the initial state
    },
  },

  extraReducers: (builder) => {
    builder
      //get list province
      .addCase(getProvinceCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProvinceCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.provinceCodeList = action.payload;
      })
      .addCase(getProvinceCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list city
      .addCase(getCityCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCityCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.cityCodeList = action.payload;
      })
      .addCase(getCityCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list district
      .addCase(getDistrictCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getDistrictCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.districtCodeList = action.payload;
      })
      .addCase(getDistrictCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list village
      .addCase(getVillageCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getVillageCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.villageCodeList = action.payload;
      })
      .addCase(getVillageCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list postal code
      .addCase(getPostalCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPostalCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.postalCodeList = action.payload;
      })
      .addCase(getPostalCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get legal code
      .addCase(getLegalCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getLegalCodeList.fulfilled, (state, action) => {
        state.loading = false; 
        state.legalCodeList = action.payload;
      })
      .addCase(getLegalCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get getTojkkabupatenkotaList
      .addCase(getTojkkabupatenkotaList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getTojkkabupatenkotaList.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .addCasegetTojkkabupatenkotaList ~ action:",
          action.payload.data
        );
        state.loading = false;
        state.kotaMadyaList = action.payload;
      })
      .addCase(getTojkkabupatenkotaList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  resetProvinceCodeList,
  resetCityCodeList,
  resetDistrictCodeList,
  resetVillageCodeList,
  resetPostalCodeList,
  resetAllZipCodeStates,
  resetLegalCodeList,
  showNotification,
  hideNotification,
  showLoading,
  setkeyCity,
} = masterZipCode.actions;

export default masterZipCode.reducer;
